export default {
      id: "oc-navbar-notify-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-navbar-notify",
      toString: function () {
        return this.url;
      }
    }